import ResolveHeaderMobile from './ResolveHeaderMobile.component';

export default ResolveHeaderMobile;
